import { render, staticRenderFns } from "./InfiniteScrollList.vue?vue&type=template&id=2bb1053f&"
import script from "./InfiniteScrollList.vue?vue&type=script&lang=js&"
export * from "./InfiniteScrollList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports